var t={monitor:1440,pc:1025,tablet:600,sp:599},a={
/** 1440px 〜 の幅に適応される */
monitor:"@media (min-width: ".concat(t.monitor,"px)"),
/** 1025px 〜 の幅に適応される */
pc:"@media (min-width: ".concat(t.pc,"px)"),
/** 〜 1024px の幅に適応される */
tablet:"@media (max-width: ".concat(t.pc-1,"px)"),
/** 〜 599px の幅に適応される */
sp:"@media (max-width: ".concat(t.tablet-1,"px)")};
/** MediaQuery */export{t as BREAK_POINTS,a as mq};
